import { render, staticRenderFns } from "./claim-application.vue?vue&type=template&id=993ed984&"
import script from "./claim-application.vue?vue&type=script&lang=js&"
export * from "./claim-application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports